<template>
  <app-button
    :color="color"
    data-cy-registration-link-cta
    :disabled="disabled"
    :loading="status === 'pending'"
    :size="size"
    :variant="variant"
    @click="register"
  >
    {{ label }}
  </app-button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";
import { endOfDay, isAfter } from "date-fns";

import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import { useRegistrationLink } from "~/business-areas/registration-link/composables/registration-link.hook";

const properties = defineProps<
  ButtonProps & { session: CourseSessionView; course: CoursePageView }
>();

const { register, status } = useRegistrationLink({
  registration_token: properties.course.registration_token,
  session: properties.session,
});

const disabled = computed(() => {
  if (
    properties.course.content_type === "MASTERCLASS" &&
    isAfter(new Date(), endOfDay(new Date(properties.session.start_date!)))
  )
    return true;

  if (
    properties.course.content_type === "COURSE" &&
    isAfter(new Date(), new Date(properties.session.start_date!))
  )
    return true;
});

const label = computed(() => {
  if (disabled.value) return "Événement passé";

  return "Réserver ma place";
});
</script>
